// extracted by mini-css-extract-plugin
module.exports = {"gameHistory":"_3ed3532","gameInfoWrapper":"_1f8c9d1","emptyData":"_d2b4cd7","noDataText":"_52bca24"};